import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mf-template-create',
  templateUrl: './template-create.component.html',
  styleUrls: ['./template-create.component.scss'],
})
export class TemplateCreateComponent {}
